import styled from 'styled-components';
import CancelPartSvg from '../../assets/mytrips/cancel-part.svg';

const CancelPartIcon = styled(CancelPartSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default CancelPartIcon;
